import { render, staticRenderFns } from "./BrandSettings.vue?vue&type=template&id=733a4a01"
import script from "./BrandSettings.vue?vue&type=script&lang=js"
export * from "./BrandSettings.vue?vue&type=script&lang=js"
import style0 from "./BrandSettings.vue?vue&type=style&index=0&id=733a4a01&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports